import type { FC } from 'react';

import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import { STEP_CHECKOUT_ASSISTANCE } from 'dibs-contact-1stdibs/exports/GetHelpModal';

import { trackFormInteraction } from '../helpers/checkoutTracking';
import { useCheckoutSelector, useAppDispatch } from '../reducers/root';
import { setCheckoutHelp } from '../actions/checkoutUIActions';
import { isEnhancedBuyerIncentivesVariant } from '../helpers/isEnhancedBuyerIncentivesVariant';

import styles from './styles/CheckoutContact.scss';

const CheckoutContact: FC = () => {
    const dispatch = useAppDispatch();
    const checkoutHelpType = useCheckoutSelector(state => state.ui.checkoutHelpType);

    const isEnhancedBuyerIncentivesClientVariant = isEnhancedBuyerIncentivesVariant();

    if (checkoutHelpType !== 'GET_HELP') {
        return null;
    }

    return (
        <Link
            dataTn="checkout-header-contact-link"
            onClick={() => {
                trackFormInteraction('email us clicked');
                dispatch(
                    setCheckoutHelp({ showCheckoutHelp: true, step: STEP_CHECKOUT_ASSISTANCE })
                );
            }}
        >
            <span className={styles.contact} data-tn="checkout-header-phonenumber">
                {isEnhancedBuyerIncentivesClientVariant ? (
                    <FormattedMessage
                        id="checkout.CheckoutContact.headerLinkVariant"
                        defaultMessage="Need assistance? <a>Contact 1stDibs</a>"
                        values={{
                            a: content => (
                                <span
                                    data-tn="checkout-header-contact-us"
                                    className={styles.emailLink}
                                >
                                    {content}
                                </span>
                            ),
                        }}
                    />
                ) : (
                    <FormattedMessage
                        id="checkout.CheckoutContact.headerLink"
                        defaultMessage="Need assistance? | <a>Contact 1stDibs</a>"
                        values={{
                            a: content => (
                                <span
                                    data-tn="checkout-header-contact-us"
                                    className={styles.emailLink}
                                >
                                    {content}
                                </span>
                            ),
                        }}
                    />
                )}
            </span>
        </Link>
    );
};

export default CheckoutContact;
